var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-tooltip',{attrs:{"right":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('span',_vm._g({staticClass:"TimeUnitSourceIcon"},on),[_c('v-icon',{class:_vm.icon.class,attrs:{"right":"","size":"14"}},[_vm._v(" "+_vm._s(_vm.icon.name)+" ")])],1)]}}])},[_c('span',[_vm._v(" "+_vm._s(("Imported from " + _vm.sourceName))+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }